import React, { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import styles from './index.module.scss'
import { sendFormData } from './utils.jsx'

import Toolbar from '../../organisms/Toolbar'
import Formbox from '../../organisms/FormBox'
import ErrorAlert from '../../molecules/ErrorAlert'
import SuccessAlert from '../../molecules/SuccessAlert'
import WarnAlert from '../../molecules/WarnAlert/index.jsx'
import ToggleButton from 'react-bootstrap/ToggleButton'
import Spinner from 'react-bootstrap/Spinner'
import { useLocation } from 'react-router-dom'


const FormGiantsysTracking = ({trackingSysId, ModelList}) => {
  const [receivedHouseData, setReceivedHouseData] = useState(null);
  const [modelList,] = useState(ModelList);
  const [formData, setFormData] = useState(null);

  const [errorData, setErrorData] = useState({ status: null, messages: null });
  const [successData, setSuccessData] = useState({ status: null, messages: null });  
  const [warnData, setWarnData] = useState(null);  
  const [house, setHouse] = useState(null);

  const handleHouseData = (data) => {
    setReceivedHouseData(data)
  };

  const handleFormChange = (data) => setFormData(data);  

  const location = useLocation();
  useEffect(()=>{
    setReceivedHouseData(null);
  }, [location])

  return (
    <div className={styles.FormGiantsysTracking}>
      <div className={styles.FormDiv}>
        <Toolbar
            Opts={modelList} 
            trackingSysId={trackingSysId} 
            onDataReceived={handleHouseData} 
            setHouse={setHouse}
            setErrorData={setErrorData} 
            setWarnData={setWarnData}
            setFormData={setFormData}/>
        {(() => {
          switch (receivedHouseData) {
            case null:
              return (<div className={styles.NotFormDiv}><div className="alert alert-danger" role="alert"><FormattedMessage id='noHouseMessage' defaultMessage="Please search for a House number."/></div></div>);

            case "Loading":
              return <Spinner animation="border" variant="danger"/>;

            default:
              return (<>
                <WarnAlert warnData={warnData} setWarnData={setWarnData}/>
                <ErrorAlert errorData={errorData} setErrorData={setErrorData}/>
                <SuccessAlert successData={successData} setSuccessData={setSuccessData}/>
                <Formbox house={house} fields={receivedHouseData} onFormChange={handleFormChange}/>
                <ToggleButton variant="primary" className={styles.FormSaveButton} onClick={() => sendFormData(formData, setSuccessData, setErrorData)} name="saveButton" id="saveButton"><FormattedMessage id='formSaveButtonText' defaultMessage="Save"/></ToggleButton>
              </>);
          }
        })()}
      </div>
    </div>
  )
}

export default FormGiantsysTracking